"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwError = exports.setErrorClass = exports.ParamInterpolatedError = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

/**
 * Default error class
 * @class ParamInterpolatedError
 */
var ParamInterpolatedError =
/*#__PURE__*/
function (_extendableBuiltin2) {
  _inherits(ParamInterpolatedError, _extendableBuiltin2);

  function ParamInterpolatedError(typeError) {
    var _this;

    _classCallCheck(this, ParamInterpolatedError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ParamInterpolatedError).call(this, "ParamInterpolatedError: ".concat(typeError.message)));
    _this.name = "ParamInterpolatedError";
    _this.stack = typeError.stack;
    return _this;
  }

  return ParamInterpolatedError;
}(_extendableBuiltin(Error));

exports.ParamInterpolatedError = ParamInterpolatedError;
var ERROR_KLASS = ParamInterpolatedError;
/**
 * Set the Error class which would be thrown when buildPath function failed
 * @param {Class} error an Error class which would be thrown
 * @example
 * // if you set
 * setErrorClass(SomeClass)
 * // when the buildPath function failed it will throw something like this
 * throw new SomeClass()
 */

var setErrorClass = function setErrorClass(error) {
  ERROR_KLASS = error;
};

exports.setErrorClass = setErrorClass;

var throwError = function throwError(e) {
  throw new ERROR_KLASS(e);
};

exports.throwError = throwError;